export default __webpack_public_path__ + "appointments/static/media/chestnut.772c6744.png";